<template>
    <div class="container">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: $myRouter.getPreviousRoute().path, params: $myRouter.getPreviousRoute().params }">返回列表</el-breadcrumb-item>
                <el-breadcrumb-item>原始记录页面</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="multi-button">
            <el-button type="danger" size="small" plain text>全部审核不通过</el-button>
            <el-button type="success" size="small" plain text>全部审核通过</el-button>
        </div>

        <el-tabs v-model="activeTab">
            <el-tab-pane label="直观报告" name="zg_report">
                <el-button type="danger" size="small" plain text>直观审核不通过</el-button>
                <el-button type="success" size="small" plain text>直观审核通过</el-button>
            </el-tab-pane>
            <el-tab-pane label="CMA报告" name="cma_report">
                <el-button type="danger" size="small" plain text>直观审核不通过</el-button>
                <el-button type="success" size="small" plain text>直观审核通过</el-button>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeTab: 'zg_report'
        }
    },
    methods: {

    },
    created() {
        this.project_id = this.$route.params.project_id;
        this.site_id = this.$route.params.site_id;
    }
}
</script>
<style scoped>
.multi-button {
    position: absolute;
    margin-right: 10px;
    right: 0;
    top: 1;
}
</style>